<template lang="pug">
          
  v-layout(sm-4 justify-center align-center)
    v-card.elevation-1
      v-img( :src='customers.data.logoUrl' aspect-ratio="2.75")
      v-progress-linear.ma-0( :indeterminate='users.loading')

      v-toolbar.elevation-0.primary
        v-toolbar-title.white--text Activar Cuenta
      v-card-text
        v-form(autocomplete='false'  @keyup.enter='validate()')
          v-autocomplete(v-if="!$route.params.customerName" label='Seleccione su empresa' :items="customerRecord" return-object item-text='name' v-model='customers.data')
          v-text-field( label="Correo" v-model='users.email' )
          v-text-field( v-model="users.password" :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'" :rules="[rules.required, rules.minEight]" :type="showPassword ? 'text' : 'password'" label="Contraseña" hint="Al menos 8 carácteres" counter @click:append="showPassword = !showPassword" )
      v-card-actions.justify-end
        v-btn.mr-2(:to='{name:"logIn", params: {customerName: $route.params.customerName} }' outlined color='primary')
          span Regresar
        v-btn.mr-2(color='primary' @click='validate()')
          span Activar cuenta  
          v-icon.ml-2 fa-sign-in-alt
      
</template>
<script>
import {auth, usersCollection} from '@/FirebaseConfig.js'
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  name: 'signUp',
  data:() => ({
    showPassword: false,
  }),
  methods: {
    ...mapActions({
      validate: 'Users/validate',
      setCustomer: 'Customers/setCustomer'
    })
  },
  created(){
    if(this.$route.params.customerName) {
      this.setCustomer(this.$route.params.customerName)
    }
  },
  computed:{
    ...mapGetters({
      customerRecord: 'Customers/publicRecord',
    }),
    ...mapState({
        users: state => state.Users,
        rules: state => state.Helpers.rules,
        customers: state => state.Customers,
      })
  },
  watch: {
    '$store.state.Customers.data'(){
      this.$vuetify.theme.primary = this.customers.data.color
      this.$route.params.customerName = this.customers.data.slug
      this.$router.replace({params: {customerName: this.customers.data.slug}})
    },
    'customerRecord'(){
      if( this.$route.params.customerName) {
        this.$store.state.Customers.data = this.customerRecord.find(item=>item.name = this.$route.params.customerName)
        document.cookie='customerName=' + encodeURIComponent( this.$route.params.customerName )
      }
    },
    
  }
}
</script>
